import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonIconComponent,
	IMenu,
	InfoGroupComponent,
	LinkComponent,
	ListDetailComponent,
	MenuComponent,
	ProfileComponent,
	TagComponent,
} from '@tecalisdev/infinity';
import { RolePermissionsService } from '../../../core/services/role-permissions.service';
import { SafeDatePipe } from '../../../core/pipes/safe-date.pipe';
import { MenuItemAction } from '../../../shared/models/master.models';
import { MasterService } from '../../../shared/services/master.service';
import { IdentityInfoTileComponent } from '../../../shared/components/identity-info-tile/identity-info-tile.component';
import { UuidFlexibleDisplayComponent } from '../../../shared/components/uuid-flexible-display/uuid-flexible-display.component';
import { IProcessDetailResponse } from '../../models/processes.models';
import { ProcessHelperService } from '../../services/process-helper.service';

@Component({
	selector: 'app-process-detail-aside',
	imports: [
		NgTemplateOutlet,
		TranslatePipe,
		SafeDatePipe,
		ProfileComponent,
		MenuComponent,
		ButtonIconComponent,
		ListDetailComponent,
		UuidFlexibleDisplayComponent,
		InfoGroupComponent,
		LinkComponent,
		TagComponent,
		IdentityInfoTileComponent,
	],
	templateUrl: './process-detail-aside.component.html',
	styleUrl: './process-detail-aside.component.scss',
})
export class ProcessDetailAsideComponent {
	@Input({ required: true }) detail!: IProcessDetailResponse;
	@Input() fullName = '';
	@Input() menuOptions: IMenu[] = [];
	@Input() menuDisabled = false;
	@Input() identityCurlPath = '';
	/** NIF-1047: lápiz de edición de identidad. */
	@Input() showEditIdentity = false;

	@Output() readonly menuAction = new EventEmitter<IMenu>();
	@Output() readonly identityMenuAction = new EventEmitter<{ action: IMenu; optionsSelected?: string[] }>();
	@Output() readonly editIdentity = new EventEmitter<void>();

	public readonly masterService = inject(MasterService);
	public readonly processHelper = inject(ProcessHelperService);
	public readonly rolePermissions = inject(RolePermissionsService);
	public readonly menuItemAction = MenuItemAction;

	public onMenu(action: IMenu): void {
		this.menuAction.emit(action);
	}

	public onIdentityMenu(action: IMenu, optionsSelected?: string[]): void {
		this.identityMenuAction.emit({ action, optionsSelected });
	}

	public onEditIdentity(): void {
		this.editIdentity.emit();
	}
}
